export default __webpack_public_path__ + "static/media/client_3.5afc68b3.png";